module.exports = __webpack_public_path__ + "img/arrow2.069dfa5a.svg";